import { Box, Typography } from '@material-ui/core';
import { isFreeTrialPaymentText } from '../../helpers/subscriptionBasedProductCodeTables';

const PaymentMethodNotes = ({ subscriptionProps }) => {
  const {
    subscriptionAmountNoteLabel,
    subscriptionAmountNoteText,
    subscriptionFirstPaymentNoteText,
  } = isFreeTrialPaymentText(subscriptionProps);
  return (
    <Box>
      <Box mb={5}>
        <Typography variant="body2">{subscriptionAmountNoteLabel}</Typography>
        <Typography variant="body2">{subscriptionAmountNoteText}</Typography>
      </Box>
      <Box mb={5}>
        <Typography variant="body2">
          {subscriptionFirstPaymentNoteText}
        </Typography>
      </Box>
    </Box>
  );
};

export default PaymentMethodNotes;
